



























import VueOptions from '@utils/VueOptions'
import payload from '@ui/Calendar/payload.json'
import OnsiteEventsCalendar from '@ui/Calendar/OnsiteEventsCalendar'
import OngoingEventsCalendar from '@ui/Calendar/OngoingEventsCalendar'
import AvailabilityHoursForm from '@ui/Calendar/AvailabilityHoursForm'
import VenueForm from '@ui/Calendar/VenueForm'
import MediaForm from '@ui/Calendar/MediaForm'

settings =
  name: 'CalendarPage'

  components: {
    OnsiteEventsCalendar,
    OngoingEventsCalendar,
    AvailabilityHoursForm,
    VenueForm,
    MediaForm,
  }

  vue:
    data: ->
      calendarType: 'onsite'

      audience_listing: payload

      audience_availability:
        availability_hours: {}
        calendar:
          seasons: []
          events: []

    computed:
      audienceAvailability: -> @audience_availability # @audience_listing.audience_availability[0]

export default VueOptions.vue settings
